import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reconciliationApi } from '../services/api-client';
import { reconciliationKeys } from './useReconciliationAlerts';
import type { ReplayWebhookResponse } from '../types';

export function useReplayWebhook() {
  const queryClient = useQueryClient();

  return useMutation<ReplayWebhookResponse, Error, string>({
    mutationFn: (webhookEventId: string) => reconciliationApi.replayWebhook(webhookEventId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reconciliationKeys.all });
    },
  });
}
